import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

const CAROUSEL_INTERVAL = 5000;

const farmImages = [
  {
    url: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1200&q=80",
    alt: "Dairy cows grazing in green UK pasture",
  },
  {
    url: "https://images.unsplash.com/photo-1603030062191-0d8a0d53ce19?w=1200&q=80",
    alt: "Sheep grazing on rolling hills",
  },
  {
    url: "https://images.unsplash.com/photo-1742921827077-dd23fc7515db?w=1200&q=80",
    alt: "Beef cattle in countryside field",
  },
  {
    url: "https://images.unsplash.com/photo-1593179357196-ea11a2e7c119?w=1200&q=80",
    alt: "Green farmland landscape",
  },
];

const CarouselContainer = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
});

const CarouselSlide = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$active",
})<{ $active: boolean }>(({ $active }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  opacity: $active ? 1 : 0,
  transition: "opacity 1s ease-in-out",
}));

const CarouselImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const CarouselDots = styled(Box)({
  position: "absolute",
  bottom: "24px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: "8px",
  zIndex: 2,
});

const Dot = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active",
})<{ $active: boolean }>(({ $active }) => ({
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  border: "none",
  backgroundColor: $active ? "#B5E48C" : "rgba(255, 255, 255, 0.5)",
  cursor: "pointer",
  padding: 0,
  transition: "background-color 0.3s ease",

  "&:hover": {
    backgroundColor: $active ? "#B5E48C" : "rgba(255, 255, 255, 0.8)",
  },
}));

export default function LoginCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % farmImages.length);
    }, CAROUSEL_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <CarouselContainer>
      {farmImages.map((image, index) => (
        <CarouselSlide key={index} $active={index === currentIndex}>
          <CarouselImage src={image.url} alt={image.alt} loading="lazy" />
        </CarouselSlide>
      ))}
      <CarouselDots>
        {farmImages.map((_, index) => (
          <Dot
            key={index}
            $active={index === currentIndex}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </CarouselDots>
    </CarouselContainer>
  );
}
